import React from 'react';

const MobileCardContainer = props => {
    return <div className='MobileCardContainer'>
        {props.children}
    </div>;
};

export default MobileCardContainer;
